// Product analytics: the demo-to-account funnel, sent to both of our
// trackers (loaded in public/index.html): PostHog, our own project, for the
// funnel and session replay; Umami for the same counts beside its visit
// stats. Each send is on its own: one tracker blocked or missing doesn't stop
// the other, and analytics never breaks the app.
//
// Events carry no personal data: no names, no emails, and page paths with
// their ids replaced, so /jobs/<id> is counted as /jobs/:id.

export const EVENTS = {
  DEMO_STARTED: 'demo_started',
  DEMO_PAGE_VIEWED: 'demo_page_viewed',
  // source: 'demo_bar' | 'sidebar' | 'demo_ended'
  DEMO_SIGNUP_CLICKED: 'demo_signup_clicked',
  // reason: 'expired' | 'exited'
  DEMO_ENDED: 'demo_ended',
  // method: 'email' | 'google' | 'apple' | 'microsoft'; from_demo: boolean
  SIGNUP_COMPLETED: 'signup_completed',
};

export function track(event, properties = {}) {
  try {
    window.posthog?.capture?.(event, properties);
  } catch {
    // Analytics is best effort
  }
  try {
    window.umami?.track?.(event, properties);
  } catch {
    // See above
  }
}

const ID_SEGMENT = /^(?=.*\d)[0-9a-f-]{8,}$/i;

/** A path with its ids replaced, so every job page counts as one page. */
export function pageName(path) {
  return path
    .split('/')
    .map((segment) => (ID_SEGMENT.test(segment) ? ':id' : segment))
    .join('/');
}

// Someone who leaves the demo for the sign-up page is logged out first, so
// the sign-up itself can't ask the store whether they came from the demo.
// This tab remembers it instead, through an OAuth round trip too.
const FROM_DEMO_KEY = 'nhd_from_demo';

export function rememberCameFromDemo() {
  try {
    sessionStorage.setItem(FROM_DEMO_KEY, '1');
  } catch {
    // Private windows may refuse storage; the sign-up still counts, just not as from the demo
  }
}

export function cameFromDemo() {
  try {
    return sessionStorage.getItem(FROM_DEMO_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Count a new account, once, and forget the demo it came from. Returns
 * whether it came from the demo, which the account's sign-up source keeps.
 */
export function trackSignup(method) {
  const fromDemo = cameFromDemo();
  track(EVENTS.SIGNUP_COMPLETED, { method, from_demo: fromDemo });
  try {
    sessionStorage.removeItem(FROM_DEMO_KEY);
  } catch {
    // See above
  }
  return fromDemo;
}
